import { useState, useCallback } from 'react';
import axios from 'axios';
import notify, { MESSAGES } from '../../../utils/notify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';
import { buildRequestImprovementBulkPayloads } from '../utils/tenderEvaluationHelpers';

const postDmut = async (endpoint, body) => {
  const token = getAuthToken();
  if (!token) {
    notify.error(MESSAGES.authRequired);
    return false;
  }

  await axios.post(`${api.API_URL}/dmut/${endpoint}`, body, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  return true;
};

const useRequestImprovement = () => {
  const [isLoading, setIsLoading] = useState(false);

  const submitBulkImprovement = useCallback(
    async ({
      improvements = [],
      message,
      closingDateImprovement,
      onSuccess,
    }) => {
      const missingMitraId = improvements.some(
        entry => !String(entry?.procurementMitraId ?? entry?.id ?? '').trim()
      );
      if (missingMitraId) {
        notify.error(
          'Procurement mitra ID was not found. Reload the offer data and try again.'
        );
        return false;
      }

      const missingCounterId = improvements.some(
        entry =>
          entry?.kind === 'counter' &&
          !String(entry?.quantityIncotermCounterId ?? '').trim()
      );
      if (missingCounterId) {
        notify.error(
          'Counter incoterm ID was not found. Reload the offer data and try again.'
        );
        return false;
      }

      const payloads = buildRequestImprovementBulkPayloads({
        improvements,
        message,
        closingDateImprovement,
      });

      if (!payloads.length) {
        notify.warning('Please select a quantity incoterm first.');
        return false;
      }

      setIsLoading(true);
      try {
        for (const { endpoint, body } of payloads) {
          const ok = await postDmut(endpoint, body);
          if (!ok) return false;
        }
        notify.success('Request improvement submitted successfully.');
        onSuccess?.();
        return true;
      } catch (err) {
        notify.apiError(err, 'submit request improvement');
        return false;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return { submitBulkImprovement, isLoading };
};

export default useRequestImprovement;
